import { render } from "./SearchRecommendPage.vue?vue&type=template&id=0e900600&ts=true"
import script from "./SearchRecommendPage.vue?vue&type=script&lang=ts"
export * from "./SearchRecommendPage.vue?vue&type=script&lang=ts"

import "./SearchRecommendPage.vue?vue&type=style&index=0&id=0e900600&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__